import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import i18nMessages from './SideMenuTranslations';

const DashboardSideMenuBuilder = (accountId) => {
  const { formatMessage } = useIntl();
  const history = useHistory();

  const buildDashboardMenu = () => {
    const dashboard = {
      label: formatMessage(i18nMessages.dashboard),
      icon: 'pi pi-eye',
      command: () => {
        const url = `/accounts/${accountId}/`;
        history.push(url);
      },
    };

    return dashboard;
  };

  return {
    buildDashboardMenu,
  };
};

export default DashboardSideMenuBuilder;
